import { useEffect, useState } from 'react'
import { COLORS } from 'consts/colors'
import EmptyState from '../Empty'
import * as Styled from '../styled'
import { useFetchAIVideoHistoryOnScroll } from '../hooks/useFetchAIVideoHistoryOnScroll'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import HistoryList from '../HistoryList'
import { DotsLoading } from 'common-components'
import { ScrollableElementProvider } from '../../context'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { FETCH_LIMIT } from 'containers/SubSidebar/AIVideoContent/consts'
import { dispatch } from 'store'

const GenerationHistory = () => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const isLoading = useSelector(aiVideoSelectors.isHistoryListLoading)
  const historyItems = useSelector(aiVideoSelectors.historyList)

  useEffect(() => {
    dispatch(aiVideoThunks.getAIVideoHistory({ offset: 0, limit: FETCH_LIMIT }))
  }, [])

  useFetchAIVideoHistoryOnScroll(container)

  const hasHistoryData = historyItems.length > 0

  return (
    <ScrollableElementProvider scrollableElementRef={{ current: container }}>
      <Styled.HistoryContainer ref={setContainer}>
        {isLoading && !hasHistoryData && (
          <DotsLoading dotColor={COLORS.primaryDark} size="small" />
        )}

        {!hasHistoryData && !isLoading && <EmptyState />}

        {hasHistoryData && (
          <>
            <HistoryList historyItems={historyItems} />
            {isLoading && (
              <DotsLoading dotColor={COLORS.primaryDark} size="small" />
            )}
          </>
        )}
      </Styled.HistoryContainer>
    </ScrollableElementProvider>
  )
}

export default GenerationHistory
